import React from 'react';
import styled from 'styled-components';

const ContainerCommunityInfo = styled.div`
  display: none;
  text-align: center;
  color: #2d3653;
  font-family: 'IBM Plex Sans JP', sans-serif;
  padding: 0px 20px;

  @media (max-width: 768px) {
    display: block;
  }
`;

const CommunityName = styled.div`
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 5px;
`;

const CommunityAddress = styled.a`
  color: #2d3653;
  text-decoration: none;
  font-size: 16px;

  &:hover {
    text-decoration: underline;
  }
`;

const CommunityPhone = styled.div`
  color: #2d3653;
  text-decoration: none;
  font-size: 16px;
`;

const CommunityInfoContainer = ({ community }) => {
  return (
    <ContainerCommunityInfo>
      <CommunityName>{community?.name || "Community"}</CommunityName>
      <CommunityAddress
        href={`https://www.waze.com/ul?ll=${community?.latitude},${community?.longitude}&navigate=yes`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {community?.address}
      </CommunityAddress>
      <CommunityPhone>{community?.phone}</CommunityPhone>
    </ContainerCommunityInfo>
  );
};

export default CommunityInfoContainer;
